import { FC } from "react";
import {
  Box,
  Alert,
  AlertIcon,
  AlertDescription,
  Text,
  Flex,
} from "@chakra-ui/react";
import { primaryColor } from "../../../utils/colors";
import { borderRadius } from "../../../utils/styles/styles";
import VerticalLine from "../../atom/Line/VerticalLine";
import CountdownTime from "./CountdownTime";
import useCountdown from "../../../hooks/countdown/useCountdown";
import SpinnerComponent from "../../atom/Spinner/SpinnerComponent";

interface AlertDateCountdownProps {
  targetDay: number;
  description: string;
  status?: "success" | "error" | "warning" | "info" | "loading";
  backgroundColor?: string;
}

const AlertDateCountdown: FC<AlertDateCountdownProps> = ({
  targetDay,
  description,
  status = "info",
  backgroundColor = primaryColor,
}) => {
  const { timeLeft, targetMonthYear } = useCountdown(targetDay, description);

  const isLoading =
    timeLeft.days === 0 &&
    timeLeft.hours === 0 &&
    timeLeft.minutes === 0 &&
    timeLeft.seconds === 0;

  return (
    <Alert
      status={status}
      backgroundColor={backgroundColor}
      borderRadius={borderRadius}
    >
      <AlertIcon boxSize="6" color="white" />
      <Box>
        <AlertDescription color="white">
          <Flex direction="row" gap={4} alignItems="center">
            <Text fontStyle="md" fontWeight="bold">
              {targetMonthYear}
            </Text>
            {isLoading ? (
              <SpinnerComponent size="lg" />
            ) : (
              <Flex direction="row">
                <CountdownTime value={timeLeft.days} label="Dias" />
                <VerticalLine />
                <CountdownTime value={timeLeft.hours} label="Horas" />
                <VerticalLine />
                <CountdownTime value={timeLeft.minutes} label="Min" />
                <VerticalLine />
                <CountdownTime value={timeLeft.seconds} label="Seg" />
              </Flex>
            )}
          </Flex>
        </AlertDescription>
      </Box>
    </Alert>
  );
};

export default AlertDateCountdown;
